
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PositionItemProps } from ".";
import { loading, find } from "store/position";

interface ApiPositionFindByIdInputProps {
    id: number;
}

type ApiPositionFindOutputProps = OutputBaseProps<{ item: PositionItemProps; }, ApiPositionFindByIdInputProps>;

export const apiPositionFindById = async (data: ApiPositionFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPositionFindOutputProps>(`/api/position/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiPositionFindByCodeInputProps {
    code: string;
}

export const apiPositionFindByCode = async (data: ApiPositionFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPositionFindOutputProps>(`/api/position/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};